/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Triple_Coin_RewardInputs */

const en_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3x focus coin`)
};

const ar_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عملة التركيز 3x`)
};

const de_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3x Fokusmünze`)
};

const es_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moneda de concentración x3`)
};

const fr_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triplez vos pièces obtenues`)
};

const it_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3x monete di concentrazione`)
};

const ja_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲得コイン3倍`)
};

const ko_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포커스 코인 3배 획득`)
};

const pt_br_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3x mais moedas`)
};

const ru_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`в 3 раза больше монет за фокусировку`)
};

const th_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เหรียญการโฟกัส 3 เท่า`)
};

const tr_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3x odaklanma jetonu`)
};

const zh_cn_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注金币 3 倍`)
};

const zh_tw_triple_coin_reward = /** @type {(inputs: Triple_Coin_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注金幣 3 倍`)
};

/**
* | output |
* | --- |
* | "3x focus coin" |
*
* @param {Triple_Coin_RewardInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const triple_coin_reward = /** @type {((inputs?: Triple_Coin_RewardInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Triple_Coin_RewardInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_triple_coin_reward(inputs)
	if (locale === "ar") return ar_triple_coin_reward(inputs)
	if (locale === "de") return de_triple_coin_reward(inputs)
	if (locale === "es") return es_triple_coin_reward(inputs)
	if (locale === "fr") return fr_triple_coin_reward(inputs)
	if (locale === "it") return it_triple_coin_reward(inputs)
	if (locale === "ja") return ja_triple_coin_reward(inputs)
	if (locale === "ko") return ko_triple_coin_reward(inputs)
	if (locale === "pt_br") return pt_br_triple_coin_reward(inputs)
	if (locale === "ru") return ru_triple_coin_reward(inputs)
	if (locale === "th") return th_triple_coin_reward(inputs)
	if (locale === "tr") return tr_triple_coin_reward(inputs)
	if (locale === "zh_cn") return zh_cn_triple_coin_reward(inputs)
	return zh_tw_triple_coin_reward(inputs)
});